import { AxiosSingleton, BaseError } from '@/common';
import { MyEmergencyPlanRegisterFormSchema, MyEmergencyPlanFormSchema, MyEmergencyPlanGetPlanDeepLinkSchema } from '@/features';
import { Axios } from 'axios';
import { container } from 'tsyringe';

export abstract class MepDataSource {
  abstract getMepDownloadUrl(data: MyEmergencyPlanFormSchema): Promise<string>;
  abstract sendMepByEmail(params: { plan: MyEmergencyPlanFormSchema; email: string }): Promise<void>;
  abstract registerForPreparednessEvent(data: MyEmergencyPlanRegisterFormSchema): Promise<void>;
  abstract getPlanDeepLink(data: MyEmergencyPlanGetPlanDeepLinkSchema): Promise<string>;
}

export class RemoteMepDataSource implements MepDataSource {
  api: Axios;

  constructor() {
    this.api = container.resolve(AxiosSingleton).ewaPublicBff;
  }

  async getMepDownloadUrl(data: MyEmergencyPlanFormSchema): Promise<string> {
    try {
      const response = await this.api.post('/mep/pdf', data);
      return response.data.url;
    } catch (error) {
      throw new BaseError('Failed to get download URL');
    }
  }

  async sendMepByEmail(params: { plan: MyEmergencyPlanFormSchema; email: string }): Promise<void> {
    try {
      await this.api.post('/mep/share/email', {
        plan: params.plan,
        email: params.email,
      });
    } catch (error) {
      throw new BaseError('Failed to send MEP by email');
    }
  }

  async registerForPreparednessEvent(data: MyEmergencyPlanRegisterFormSchema): Promise<void> {
    try {
      await this.api.post('/mep/register-for-event', { details: data });
    } catch (error) {
      throw new BaseError('Failed to register for preparedness event');
    }
  }

  async getPlanDeepLink(data: MyEmergencyPlanGetPlanDeepLinkSchema): Promise<string> {
    try {
      const response = await this.api.post('/mep/share/in-app/deep-link', data);
      return response.data.url;
    } catch (error) {
      throw new BaseError('Failed to get plan deep link');
    }
  }
}
